export default abstract class editable {

    edit = false;
}